
import Logo from "@/components/shared/Logo";

const CaymanFooter = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12 px-4">
      <div className="container mx-auto max-w-6xl flex flex-col items-center text-center">
        <Logo className="h-8 mb-4" variant="dark" />
        <p className="text-sm opacity-70 max-w-md text-center mx-auto mb-6">
          NationCard™ is a civic engagement platform designed to keep democracy
          alive between elections. Our mission is to increase transparency and
          accountability in government through ongoing citizen participation.
        </p>

        <div className="border-t border-gray-800 mt-6 pt-6 w-full text-center">
          <p className="text-sm opacity-50">
            © {new Date().getFullYear()} NationCard™. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default CaymanFooter;
